module.exports = {
    NEW_WEBSITE_PATH: 'new-website'
}
